<template>
  <div class="box4">
    <img src="../../../assets/coursePage/media/box4/img.png" alt="" />
    <p class="info">
      CSM数据调研显示：
      <span>44.1%</span>的短视频用户在短视频客户端上购物变多。
    </p>
    <p class="info">
      以抖音电商为例，同比2021年，抖音商城访问PV增长
      <span>518%，</span>
      商城GMV同比增长<span>434%；</span>店铺访问PV增长
      <span>197%，</span>店铺GMV增长 <span>428%。</span>
    </p>

    <div class="tip">
      数据来源：《【CSM】短视频用户价值研究报告2022》、《用内容创造消费流行 |
      2022抖音电商商品发展报告》
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.box4 {
  position: relative;
  width: 100%;

  overflow: hidden;
  img {
    width: 628px;
    height: 332px;
    display: block;
    margin: 16px auto 32px;
  }
  .info {
    text-align: justify;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #555266;
    line-height: 40px;
    padding: 0 32px;
    box-sizing: border-box;
    margin-bottom: 16px;
    span {
      color: rgba(255, 0, 0, 1);
      font-family: PingFangSC-Medium;
      font-size: 24px;
    }
  }
  .tip {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #bac2d0;
    line-height: 36px;
    padding: 0 32px;
    box-sizing: border-box;
  }
}
</style>
